import React from 'react';
import PillsList from '../PillsListComponent';

import { Typography, Stack, Divider } from '@mui/joy';
import Rating from "@mui/material/Rating"
import { Star } from '@mui/icons-material';

import '../../styles/reviews.scss';

const helper = require('../../Helpers/helpers');

function FeedbackResultComponent({ feedback }: any) {
    return (
        <div className='mb-1 pb-2'>
            <div className="row mt-2 review-item border-bottom">
                <div className="col-md-auto border-end">
                    <Stack
                        direction="column"
                        spacing={1}
                        sx={{
                            justifyContent: "left",
                            alignItems: "left",
                        }}
                    >
                        {feedback.device && (
                            <div className='row'>
                                <div className='col-auto'>
                                    <Typography
                                        color='neutral'
                                        level='body-xs'>
                                        Device
                                    </Typography>
                                </div>
                                <div className='col-auto my-auto'>
                                    <Typography
                                        color='neutral'
                                        level='body-xs'
                                        fontWeight={700}>
                                        {feedback.device}
                                    </Typography>
                                </div>
                            </div>
                        )}

                        {feedback.os && (
                            <div className='row'>
                                <div className='col-auto'>
                                    <Typography
                                        color='neutral'
                                        level='body-xs'>
                                        OS
                                    </Typography>
                                </div>
                                <div className='col-auto my-auto'>
                                    <Typography
                                        color='neutral'
                                        level='body-xs'
                                        fontWeight={700}>
                                        {feedback.os}
                                    </Typography>
                                </div>
                            </div>
                        )}

                        {feedback.version && (
                            <div className='row'>
                                <div className='col-auto'>
                                    <Typography
                                        color='neutral'
                                        level='body-xs'>
                                        Version
                                    </Typography>
                                </div>
                                <div className='col-auto my-auto'>
                                    <Typography
                                        color='neutral'
                                        level='body-xs'
                                        fontWeight={700}>
                                        {feedback.version}
                                    </Typography>
                                </div>
                            </div>
                        )}
                        <Divider />
                        {feedback.metadata && feedback.metadata.length > 0 && (
                            <>
                                <Typography
                                    color='neutral'
                                    level='body-xs'
                                    sx={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                                    Metadata
                                </Typography>
                                {
                                    feedback.metadata.map((item: any, index: number) => {
                                        const keyValue = helper.parseKeyValue(item);
                                        return keyValue ? (
                                            <div className='row' key={index}>
                                                <div className='col-auto'>
                                                    <Typography
                                                        color='neutral'
                                                        level='body-xs'
                                                        sx={{ fontStyle: 'italic' }}>
                                                        {keyValue.key}
                                                    </Typography>
                                                </div>
                                                <div className='col-auto my-auto'>
                                                    <Typography
                                                        color='neutral'
                                                        level='body-xs'
                                                        fontWeight={700}
                                                        sx={{
                                                            wordBreak: 'break-word',
                                                            maxWidth: '200px'
                                                        }}>
                                                        {keyValue.value}
                                                    </Typography>
                                                </div>
                                            </div>
                                        ) : null;
                                    })
                                }
                            </>
                        )}
                    </Stack>
                </div>

                <div className='col'>
                    <div className='row'>
                        <div className="ml-0">
                            <div className='row mb-3'>
                                {feedback.rating && (
                                    <div className='col-auto'>
                                        <Rating
                                            value={Number(feedback.rating)}
                                            readOnly size="small"
                                            emptyIcon={
                                                <Star
                                                    style={{ opacity: 0.55 }}
                                                    fontSize="inherit" />
                                            }
                                        />
                                    </div>
                                )}
                                <div className='col-auto'>
                                    <Typography
                                        level='body-xs'
                                        sx={{
                                            color: '#a1a1a1'
                                        }}>
                                        {feedback.date &&
                                            <>
                                                {helper.timeSince(feedback.date)}
                                            </>
                                        }
                                    </Typography>
                                </div>
                            </div>
                            <Typography
                                level='body-sm'
                                sx={{
                                    marginBottom: 2,
                                    lineHeight: 1.4
                                }}>
                                {feedback.feedback}
                            </Typography>
                            <div>
                                <PillsList color='primary' keywords={feedback.answers} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FeedbackResultComponent;